import React from 'react';
import Script from 'next/script';
import AnalyticScript from 'tracking/src/Script';
import type { AppProps } from 'next/app';
import withLayoutHOC from 'components/withLayoutHOC';

import '../styles/globals.scss';

function MyApp({ Component, pageProps }: AppProps) {
  const ComponentWithLayout = withLayoutHOC(Component);

  return (
    <>
      {/* Anti-flicker snippet */}
      <Script id="anti-flicker-snippet" strategy="afterInteractive">
        {`
        (function(a, s, y, n, c, h, i, d, e) {
          s.className += ' ' + y;
          h.start = 1 * new Date;
          h.end = i = function() {
            s.className = s.className.replace(RegExp(' ?' + y), '')
          };
          (a[n] = a[n] || []).hide = h;
          setTimeout(function() {
            i();
            h.end = null
          }, c);
          h.timeout = c;
        })(window, document.documentElement, 'async-hide', 'dataLayer', 1500, {
          'GTM-M79R6L5': true
        });
      `}
      </Script>

      {/* Google GA4 */}
      <AnalyticScript async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA4}`} />
      <AnalyticScript id="google-ga4" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${process.env.NEXT_PUBLIC_GA4}', {
            send_page_view: true,
            cookie_flags: "SameSite=None;Secure"
          });
      
          gtag('get', '${process.env.NEXT_PUBLIC_GA4}', 'client_id', function (value) {
            gtag('set', 'user_properties', {
              ga_client_id: value
            });
          });
      
          gtag('get', '${process.env.NEXT_PUBLIC_GA4}', 'session_id', function(value) {
            gtag('set', {
                'ga_session_id': value
            });
          });
        `}
      </AnalyticScript>

      {/* Google Tag Manager */}
      <AnalyticScript id="google-tag-manager" strategy="afterInteractive">
        {`
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-M79R6L5');
      `}
      </AnalyticScript>

      <AnalyticScript id="mutiny-tag" strategy="afterInteractive">
        {`
       (function(){var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d});setTimeout(d,500)})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();
      `}
      </AnalyticScript>

      <AnalyticScript
        data-cfasync="false"
        src="https://client-registry.mutinycdn.com/personalize/client/3cbdefc4f1c9f2bf.js"
        strategy="afterInteractive"
      />

      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ComponentWithLayout {...pageProps} />
    </>
  );
}

export default MyApp;
